<template>
  <div class="myComment">
    <div class="personal-box comWidth">
      <!--<CenterNav/>-->
      <div class="personal-right">
        <NavT :titleS="titleS"/>
        <div class="rightmain">
          <el-table
            :data="goodsList"
            style="width: 100%">
            <el-table-column
              label="商品信息"
              width="260">
              <template slot-scope="scope">
                <img :src="scope.row.goods_thumb_url"><span>{{scope.row.goods_traditional_name}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="商品數量"
              width="180">
              <template  slot-scope="scope">{{scope.row.goods_number}}</template>
            </el-table-column>
            <el-table-column
              label="運單號"
              width="180">
              <template  slot-scope="scope">{{scope.row.tracking_no}}</template>
            </el-table-column>
            <el-table-column
              prop="amount"
              label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="see(scope.row)"
                  type="danger"
                  size="small">
                  查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
  //nav
  import NavT from '@/pages/personalPage/NavT'
  //cNav
  import CenterNav from '@/pages/personalPage/CenterNav'
  //api
  import {deliveryBills } from '@/api/order'
  export default {
    name: 'MyPackage',
    components:{
      NavT,
      CenterNav
    },
    data () {
      return {
        titleS:' 跟蹤包裹',
        orderId:this.$route.query.id, // 订单id
        goodsList:[], // 订单发货列表
      }
    },
    methods:{
      /*获取订单发货列表*/
      getDeliverGoods(){
        deliveryBills(this.orderId).then(res=>{
            this.goodsList = res.data.data
        })
      },
      /*查看物流*/
      see(item){
          this.$router.push({
            name:"LogisticsDetails",
            query:{
              bill:item.id
            }
          })
      }
    },
    created(){
      window.scrollTo(0,0)
      //获取订单发货列表
      this.getDeliverGoods()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/personalPage/orderCenter/MyPackage.vue